import React, { lazy } from 'react'
import { Route } from 'react-router'

import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))

export const AssetResourceRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--human-resources--asset-resource']}>
    <Route path='*' element={<Index />} />
  </SubRouter>
))
